export const FAQ_ENTRIES = [
    {
        q: 'Do I need the physical Secret Hitler game?',
        a: 'No. The app replaces every physical component - the role cards, the party membership ' +
            'cards, the ballots, the policy tiles, the board and the placards. You need five to ten ' +
            'people and a phone each.',
    },
    {
        q: 'Can I play Secret Hitler online with this?',
        a: 'Yes, with one caveat: bring your own voice chat. Everyone opens the same lobby code from ' +
            'wherever they are and the game runs exactly as it does at a table. What it does not ship ' +
            'is chat or voice, because it was built for people already talking out loud in one room. ' +
            'Over a call on Discord, Zoom or anything else, it works.',
    },
    {
        q: 'How many phones do we need?',
        a: 'One each. You can also open the shared board on a laptop or a TV, on as many screens as you ' +
            'like, but that is optional - the game runs perfectly well on phones alone.',
    },
    {
        q: 'Is it free?',
        a: 'Yes, and it has no ads, no accounts and no sign-up. Secret Hitler is licensed ' +
            'non-commercially, so this adaptation cannot be sold or monetised and is not trying to be.',
    },
    {
        q: 'How many players do you need for Secret Hitler?',
        a: 'Five at minimum and ten at most. Table size genuinely changes the game: the split of ' +
            'liberals to fascists shifts, the presidential powers on the board move, and from seven ' +
            'players up Hitler is no longer told who his fascists are.',
    },
    {
        q: 'Can other people see my role on my screen?',
        a: 'Only if you show them. Every secret is hidden until you ask for it, and while it is hidden ' +
            'it is not on the page at all. Your role and an investigation result sit behind a ' +
            'press-and-hold veil: let go and they are gone. The policies you drew are shown and hidden ' +
            'with a button, because you have to think with them in front of you - and they put ' +
            'themselves away the moment you switch tabs or lock the phone.',
    },
    {
        q: 'What happens if a phone dies in the middle of a game?',
        a: 'That player opens the site on any device and joins the lobby under the same name they ' +
            'were playing under; the game recognises the seat and asks for a claim PIN. The host ' +
            'issues one from Host tools and reads it out. The old device is invalidated and the game ' +
            'continues, role and all.',
    },
    {
        q: 'Does the game survive a refresh or a lost connection?',
        a: 'Yes. Your seat is held by a token in the browser, so a refresh, a screen lock or a dropped ' +
            'connection costs nothing. The server also snapshots every lobby to disk, so a restart or a ' +
            'crash does not kill a game in progress.',
    },
    {
        q: 'Is there a game log to check what happened earlier?',
        a: 'Deliberately not. The board shows what a physical table would show right now. Arguing about ' +
            'what happened three rounds ago is the game, not a feature.',
    },
    {
        q: 'What is it like to play remotely?',
        a: 'Workable, and a little more demanding than at a table. A few things are tuned for people ' +
            'who can see each other: you are told who your fellow fascists are once and never again, a ' +
            'cast ballot is not shown back to you, there is no game log to scroll, and nothing is ever ' +
            'timed out, so the table waits on whoever wandered off. None of that stops a game; it just ' +
            'means everyone has to pay attention the way they would in person.',
    },
    {
        q: 'Do we need a moderator or a narrator?',
        a: 'No. The app deals the roles, runs the reveal, collects the votes simultaneously, enforces ' +
            'term limits and executions, and applies the presidential powers. Nobody has to sit out to ' +
            'run it.',
    },
];
//# sourceMappingURL=faq.js.map